const ExpenseTypesApi = {
  base: '/expense-types',
};

export default ExpenseTypesApi;
